export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.pageStructureData = payload;

  return newState;
};
